var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "avue-form",
        {
          attrs: { option: _vm.optionPeriod },
          on: { submit: _vm.submitPeriod },
          scopedSlots: _vm._u([
            {
              key: "today",
              fn: function (scope) {
                return [_c("span", [_vm._v(_vm._s(scope.value))])]
              },
            },
            {
              key: "period",
              fn: function (scope) {
                return [_c("span", [_vm._v(_vm._s(scope.value) + "天")])]
              },
            },
            {
              key: "defeasanceDate",
              fn: function (scope) {
                return [_c("span", [_vm._v(_vm._s(scope.value))])]
              },
            },
            {
              key: "shortRate",
              fn: function (scope) {
                return [_c("span", [_vm._v(_vm._s(scope.value) + "%")])]
              },
            },
            {
              key: "endorsePremium",
              fn: function (scope) {
                return [_c("span", [_vm._v(_vm._s(scope.value) + "元")])]
              },
            },
          ]),
          model: {
            value: _vm.formPeriod,
            callback: function ($$v) {
              _vm.formPeriod = $$v
            },
            expression: "formPeriod",
          },
        },
        [
          _c(
            "template",
            { slot: "effectiveDate" },
            [
              _c("el-date-picker", {
                attrs: {
                  disabled: _vm.isSubmitted,
                  "picker-options": _vm.pickerOptions,
                  format: "yyyy-MM-dd",
                  placeholder: "请选择 生效日期",
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                },
                on: { change: _vm.effectiveDateChanged },
                model: {
                  value: _vm.formPeriod.effectiveDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.formPeriod, "effectiveDate", $$v)
                  },
                  expression: "formPeriod.effectiveDate",
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "menuForm" },
            [
              _vm.isSubmitted
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-edit" },
                      on: { click: _vm.modifyPeriod },
                    },
                    [_vm._v("修改")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c("span", { staticClass: "red-bold" }),
      _c("endorse-time-hint-dialog", {
        ref: "timeHintDialog",
        attrs: { "last-time-data": _vm.lastTimeData },
        on: { onEndorseTimeSure: _vm.onShowInsureData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }